
import { Component } from 'vue-property-decorator';
import ListBase from '@/lib/listbase';
import PageRequest from '@/store/entities/page-request';
import ListView from '@/components/helper/list-view.vue';
import FormBase from '@/components/helper/form-base.vue';
import UserForm from './user-form.vue';

class PageUserRequest extends PageRequest {
    role: string = '';
}

@Component({
    components: { ListView, UserForm, FormBase }
})
export default class Users extends ListBase {
    entity: string = 'user';
    pagerequest: PageUserRequest = new PageUserRequest();
    filterForm: boolean = true;

    filterItems = [
        this.gItem({ type: 'object', prop: 'role', label: 'Buscar por Rol', size: 12, hideDetails: true, onchange: this.afterSave }),
    ]

    columns = [
        this.gCol('first_name', 'Nombre', 'text'),
        this.gCol('last_name', 'Apellidos', 'text'),
        this.gCol('username', 'Usuario', 'text'),
        this.gCol('active', 'Habilitado', 'text'),
        this.gColO({ type: 'list', value: 'roles', text: 'Roles' }),
        this.defaultActions()
    ]

    get exluddeIds() {
        let ids = [];
        this.$store.state.user.list.forEach(item => {
            if (item.id == 1)
                ids.push(item.id);
        });

        return { delete: ids };
    }

    edit() {
        this.modalShow = !this.modalShow;
    }
    create() {
        this.modalShow = !this.modalShow;
    }
    async afterSave() {
        let list: any = this.$refs.listView
        await list.getpage();
    }

    //avatar_type: string;
    //avatar_location: string;

    created() {

    }
}
